<template>
  <el-dialog
    title="审批"
    class="mini-dialog approval-dialog"
    :visible.sync="dialogVisible"
    v-dialogDrag
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
  >
    <el-form :model="form" :rules="rules" label-width="150px" label-position="right" ref="form">
      <el-form-item label="审批结果" prop="isPass">
        <el-radio-group v-model="form.isPass" @input="passChange">
          <el-radio :label="0">通过</el-radio>
          <el-radio :label="1">不通过</el-radio>
          <el-radio :label="2">否决</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 党建宣传员审批 -->
      <el-form-item
        label="是否重要稿件"
        prop="isImportantInfo"
        v-if="flow.stepId === config.partyPropagandistStepId"
      >
        <el-radio-group v-model="form.isImportantInfo">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="flow.stepId === config.partyLeadershipStepId && form.isPass === 0"
        prop="userIds"
        label="审批人员"
      >
        <el-select
          v-model="form.userIds"
          multiple
          class="w-100"
          size="small"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in handlerData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item v-if="!form.isPass" prop="backStepId" label="退回节点">
        <el-select v-model="form.backStepId" class="w-100" size="small" placeholder="请选择">
          <el-option
            v-for="item in backStepList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="审批意见" prop="approve">
        <el-input
          type="textarea"
          maxlength="500"
          :rows="3"
          v-model="form.approve"
          placeholder="请输入"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ColumnFlowApi } from '@wiz-api/workbench'

const { config } = Wiz.globalSettings.dynamicModules.modules['portal-management-nanhai']
const columnFlowApi = new ColumnFlowApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        isPass: 0,
        isImportantInfo: null,
        approve: '',
        userIds: [],
        backStepId: '',
      },
      rules: {
        isPass: [{ required: true, message: '请选择审批结果', trigger: 'change' }],
        isImportantInfo: [{ required: true, message: '请选择是否重要稿件', trigger: 'change' }],
        userIds: [{ required: true, message: '请选择审批人员', trigger: 'change' }],
        backStepId: [{ required: true, message: '请选择退回节点', trigger: 'change' }],
      },
      flow: {},
      handlerData: [],
      backStepList: [],
      config,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getTaskInfo()
      }
    },
  },
  methods: {
    passChange() {
      this.form.userIds = []
      this.form.backStepId = ''
    },
    async getTaskInfo() {
      const [err, res] = await columnFlowApi.getFlowTaskInfo({
        flowTaskId: this.data.taskId,
      })
      if (!err) {
        this.flow = res
        // this.getFlowStep()
        if (this.flow.stepId === config.partyPropagandistStepId) {
          this.form.isImportantInfo = false
        }
        if (this.flow.stepId === config.partyLeadershipStepId) {
          this.getNextStepHandler()
        }
      }
    },
    async getFlowStep() {
      const [err, res] = await columnFlowApi.getFlowProcess({
        userId: this.userInfo?.profile?.sub,
        taskId: this.data.taskId,
      })
      if (!err) {
        this.backStepList = _.filter(res, (item) => {
          return item.status === 1
        })
      }
    },
    async getNextStepHandler() {
      const [err, res] = await columnFlowApi.getStepDefaultHanderByName({
        userId: this.userInfo?.profile?.sub,
        flowId: this.flow.flowId,
        stepName: config.companyLeadershipStepName,
      })
      if (!err) {
        this.handlerData = res
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.data.taskId) {
            this.$message.warning('未获取到下一步审批节点!')
            return
          }
          const [err] = await columnFlowApi.approve({
            body: {
              ...this.form,
              ...this.data,
              isPass: this.form.isPass !== 1,
              isFinished: this.form.isPass === 2 ? true : null,
            },
          })
          if (!err) {
            this.$message.success('审批成功!')
            this.$emit('save')
            this.closeDialog()
          }
        }
      })
    },
    closeDialog(done) {
      this.form = this.$options.data().form
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style lang="scss">
.approval-dialog {
  .el-dialog__body {
    overflow: unset;
  }
}
</style>
